"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasPhone = void 0;
var hasPhone = exports.hasPhone = function hasPhone(text) {
  var regex = new RegExp('(?:([\\s\\.,!?:;]{1}|^))((?:[\\(]?\\s*[1-9]{2}\\s*[\\)-]?\\s*)?[2-9][0-9]{3,4}[-,\\s\\.]*[0-9]{4})', 'g');
  return regex.test(text);
};